import { Typography, useMediaQuery, useTheme } from "@mui/material";

interface InfoItemProps {
  image?: any;
  title?: string;
  value?: string | number | null;
}

const InfoItem = ({ image, title, value }: InfoItemProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Typography
      sx={{
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        color: "#000",
      }}
    >
      {image && (
        <img
          src={image}
          alt="image"
          style={{ width: "15px", marginRight: "5px" }}
        />
      )}
      <Typography
        component="span"
        sx={{ fontWeight: "600", fontSize: isMobile ? "15px" : "17px" }}
      >
        {title}
      </Typography>
      <Typography
        component="span"
        sx={{
          fontWeight: "normal",
          fontSize: isMobile ? "15px" : "17px",
          marginLeft: "3px",
        }}
      >
        {value}
      </Typography>
    </Typography>
  );
};

export default InfoItem;
